<template>
  <b-container fluid>
    <AddDevice :rest_home_id="rest_home_id" @created="getDevices" />
    <ViewDevice
      :rest_home_id="rest_home_id"
      :device="device"
      @updated="getDevices"
      @close="device = null"
    />
    <b-row align-v="center">
      <b-col>
        <b-checkbox
          :value="1"
          :unchecked-value="0"
          v-model="allowed_devices_active"
          @change="setAllowedDevicesActive"
        >
          CONTROLE DE DISPOSITIVOS ATIVO
        </b-checkbox>
      </b-col>
      <b-col cols="auto">
        <v-btn
          v-if="permissions.rest_home.edit"
          class="v-primary mb-1"
          @click="$bvModal.show('modal_add_device')"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
      </b-col>
    </b-row>
    <ErrorsMessages :errors="errors" />
    <v-card>
      <v-card-title>
        Dispositivos
        <v-switch
          label="Mostrar inativos"
          v-model="show_inactive"
          @change="getDevices()"
        />
        <v-spacer />
        <v-text-field
          dense
          outlined
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          hide-details
        />
      </v-card-title>
      <v-data-table
        dense
        :headers="headers"
        :items="devices"
        :footer-props="{
          'items-per-page-options': [25, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="device = $event"
      >
        <template v-slot:[`item.allowed_by`]="{ item }">
          {{ item.allowed_by ? item.allowed_by : "ADMINISTRADOR" }}
        </template>
        <template v-slot:[`item.code`]="{ item }">
          {{ item.code == null ? "Já utilizada" : item.code }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status == 1 ? "Liberado" : "Bloqueado" }}
        </template>
        <template v-slot:[`item.last_login`]="{ item }">
          {{
            item.last_login
              ? `${item.last_login_name} em ${formatDate(
                  item.last_login,
                  true
                )}`
              : "Não acessado"
          }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at, false) }}
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          {{ formatDate(item.updated_at, false) }}
        </template>
      </v-data-table>
    </v-card>
  </b-container>
</template>

<script>
import AddDevice from "./Devices/AddDevice";
import ViewDevice from "./Devices/ViewDevice.vue";
import ErrorsMessages from "../components/ErrorsMessages";
import api from "../../services/api";
import { formatDate } from "../../functions/format";
import { adminData, dialogConfirm } from "../../lib/functions";
import toast from "../../components/ToastNotification";

export default {
  name: "RestHomeDevices",

  components: {
    AddDevice,
    ViewDevice,
    ErrorsMessages,
  },

  data() {
    return {
      permissions: {},
      errors: [],

      loading: true,

      rest_home_id: "",
      id: "",

      allowed_devices_active: 0,

      device: null,

      search: "",
      headers: [
        { text: "Dispositivo", value: "name" },
        { text: "Concessor", value: "allowed_by" },
        { text: "Chave", value: "code" },
        { text: "Status", value: "status" },
        { text: "Último acesso", value: "last_login" },
        { text: "Registrado", value: "created_at" },
        { text: "Modificado", value: "updated_at" },
      ],
      devices: [],
      show_inactive: false,
    };
  },

  created() {
    this.permissions = adminData().permissions;

    const { id } = this.$attrs;
    this.rest_home_id = id;

    this.getDevices();
    this.getAllowedDevicesActive();
  },

  methods: {
    formatDate,
    dialogConfirm,

    async getDevices() {
      try {
        this.loading = true;

        let params = {
          rest_home_id: this.rest_home_id,
          show_inactive: this.show_inactive,
        };
        let response = await api.get("/admin/rest-home/devices/paginate", {
          params,
        });
        let { error, errors, devices } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.devices = devices;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getAllowedDevicesActive() {
      try {
        this.loading = true;

        let params = { rest_home_id: this.rest_home_id };
        let response = await api.get(
          "/admin/rest-home/settings/security/allowed-devices-active",
          {
            params,
          }
        );
        let { error, errors, allowed_devices_active } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.allowed_devices_active = allowed_devices_active;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async setAllowedDevicesActive(allowed_devices_active) {
      try {
        this.loading = true;

        const data = {
          rest_home_id: this.rest_home_id,
          allowed_devices_active,
        };
        const response = await api.patch(
          "/admin/rest-home/settings/security/allowed-devices-active",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>